import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AbstractDynamicForm, FormControlWrapper } from '../../../dynamic-form-abstract';

@Component({
	selector: 'app-dynamic-form-input-msisdn',
	standalone: false,
	templateUrl: './dynamic-form-input-msisdn.component.html',
	styleUrl: './dynamic-form-input-msisdn.component.scss'
})
export class DynamicFormInputMsisdnComponent {
	@Input() wrapper!: FormControlWrapper;
	@Input() form!: FormGroup;
	@Input() inline: boolean = false;
	@Input() readonly = false;
	@Input() span = 0;
	toControlKey = AbstractDynamicForm.toControlKey;

}
